'use es6';

import { registerQuery } from 'data-fetching-client';
import { http } from '../features/http';
export const TRACKS_LESSONS_SEARCH = registerQuery({
  fieldName: 'tracksLessonsSearchResults',
  args: ['durations', 'languages', 'categories', 'hubSpotSoftware', 'levels', 'contentTypes', 'search', 'partnersOnly'],

  fetcher({
    durations,
    languages,
    categories,
    hubSpotSoftware,
    levels,
    contentTypes,
    search,
    partnersOnly
  }) {
    return http.get('/academy/v1/search', {
      query: {
        durations,
        languages,
        categories,
        hubSpotSoftware,
        levels,
        contentTypes,
        search,
        partnersOnly
      }
    }).then(data => data.results);
  }

});